import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import { productImagePlaceholder } from '../helpers'
import SubmitButton from './elements/SubmitButton'
import { convertToImgixImage, isMobile } from './Product'


export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()
    const [sortedKeywords, setSortedKeywords] = useState(keywords)

    useEffect(() => {
        const sortedHits = keywords.hits.map(hit => {
            const sortedFacets = hit.facets.map(facet => {
                const sortedData = [...facet.data].sort((a, b) => b.count - a.count);
                return { ...facet, data: sortedData };
            });
            return { ...hit, facets: sortedFacets };
        });
    
        const sortedKeywords = { ...keywords, hits: sortedHits };
        setSortedKeywords(sortedKeywords);
    }, [keywords]);

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box"
            data-nosto-element="autocomplete">
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {isMobile && (
                        <div class="ns-flex-column.ns-col-12 select-all-sticky-on-mobile">
                            <SubmitButton text="Se alle søkeresultater" />
                        </div>
                    )}
                    {sortedKeywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? 'ns-col-sm-4' : 'ns-col-sm-12'
                            }`}>
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={sortedKeywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-d-flex ns-flex-column">
                                {products?.hits?.map((hit) => {
                                    return (
                                        <div class="ns-autocomplete-element">
                                        {/* <AutocompleteElement hit={hit}> */}
                                            <a
                                                href={hit.url}
                                                class="ns-d-flex flex-row ns-clickable ns-p-2"
                                                data-nosto-element="product">
                                                <img
                                                    class="ns-h-auto ns-object-contain"
                                                    src={
                                                        convertToImgixImage(hit.imageUrl, 300) ??
                                                        productImagePlaceholder
                                                    }
                                                    alt={hit.name}
                                                    width="60"
                                                    height="40"
                                                    style={'max-height: 80px;'}
                                                    loading="lazy"
                                                />
                                                <div class="ns-pl-2">
                                                    {hit.brand && (
                                                        <div class="ns-color-black ns-mb-1 ns-font-4">
                                                            {hit.brand}
                                                        </div>
                                                    )}
                                                    <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
                                                        {hit.name}
                                                    </div>
                                                    <div>
                                                        <span>{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </a>
                                        {/* </AutocompleteElement> */}
                                        </div>
                                    )
                                })}
                            </div>
                            {!isMobile && <SubmitButton text="Se alle søkeresultater" />}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword,
                    }}></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{' '}
                    <span class="category-name">
                        i <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
